import type { Currency$options } from '$houdini';
import * as m from '$paraglide/messages';

// TODO: Add all the currencies
const currencyPriceRangeLabel: Record<
	Currency$options,
	(options: { minAmount: number; maxAmount: number }) => string
> = {
	eur: m.poi_filters__value_label__price_range__eur,
	usd: m.poi_filters__value_label__price_range__usd,
	gbp: m.poi_filters__value_label__price_range__eur,
	jpy: m.poi_filters__value_label__price_range__eur,
	chf: m.poi_filters__value_label__price_range__eur,
	czk: m.poi_filters__value_label__price_range__eur,
	dkk: m.poi_filters__value_label__price_range__eur,
	hrk: m.poi_filters__value_label__price_range__eur,
	huf: m.poi_filters__value_label__price_range__eur,
	nok: m.poi_filters__value_label__price_range__eur,
	pln: m.poi_filters__value_label__price_range__eur,
	sek: m.poi_filters__value_label__price_range__eur,
	uah: m.poi_filters__value_label__price_range__eur,
};

export function currencyPriceRange(
	currency: Currency$options,
	options: { minAmount: number; maxAmount: number },
): string {
	return currencyPriceRangeLabel[currency](options);
}

const currencyMinPriceLabel: Record<Currency$options, (options: { amount: number }) => string> = {
	eur: m.poi_filters__value_label__min_price__eur,
	usd: m.poi_filters__value_label__min_price__usd,
	gbp: m.poi_filters__value_label__min_price__eur,
	jpy: m.poi_filters__value_label__min_price__eur,
	chf: m.poi_filters__value_label__min_price__eur,
	czk: m.poi_filters__value_label__min_price__eur,
	dkk: m.poi_filters__value_label__min_price__eur,
	hrk: m.poi_filters__value_label__min_price__eur,
	huf: m.poi_filters__value_label__min_price__eur,
	nok: m.poi_filters__value_label__min_price__eur,
	pln: m.poi_filters__value_label__min_price__eur,
	sek: m.poi_filters__value_label__min_price__eur,
	uah: m.poi_filters__value_label__min_price__eur,
};

export function currencyMinPrice(currency: Currency$options, options: { amount: number }): string {
	return currencyMinPriceLabel[currency](options);
}

const currencyPriceLabel: Record<Currency$options, (options: { amount: number }) => string> = {
	eur: m.poi_filters__value_label__price__eur,
	usd: m.poi_filters__value_label__price__usd,
	gbp: m.poi_filters__value_label__price__eur,
	jpy: m.poi_filters__value_label__price__eur,
	chf: m.poi_filters__value_label__price__eur,
	czk: m.poi_filters__value_label__price__eur,
	dkk: m.poi_filters__value_label__price__eur,
	hrk: m.poi_filters__value_label__price__eur,
	huf: m.poi_filters__value_label__price__eur,
	nok: m.poi_filters__value_label__price__eur,
	pln: m.poi_filters__value_label__price__eur,
	sek: m.poi_filters__value_label__price__eur,
	uah: m.poi_filters__value_label__price__eur,
};

export function currencyPrice(currency: Currency$options, options: { amount: number }): string {
	return currencyPriceLabel[currency](options);
}
